export default {"src":"/_next/static/media/group-gradient.8275e1af.svg","height":451,"width":1280,"blurWidth":0,"blurHeight":0};